export default __webpack_public_path__ + "static/media/9hoooks.c86a95fa.webp";